<template>
  <div class="person__form_outer">
    <h3 class="d-none d-md-block">{{title}}</h3>
    <h5 class="d-block d-md-none">{{title}}</h5>
    <div class="person__form">

      <b-form-group horizontal
                    description="Please add your name to sign the Charter."
                    label="Name"
                    label-cols="2"
                    label-size="lg"
                    label-text-align="left"
                    breakpoint="md"
                    :invalid-feedback="invalidMessageName"
                    :valid-feedback="validMessageName"
      >
        <b-form-input
          :state="validName($store.person.name)"
          placeholder="Your name"
          v-model="$store.person.name"
          class="w-100 w-md-75"
        ></b-form-input>
      </b-form-group>

      <b-form-group horizontal
                    description="Please let us know your email address. We will not publish your email or spam you."
                    label="Email Address"
                    label-cols="2"
                    label-size="lg"
                    label-text-align="left"
                    breakpoint="md"
                    :invalid-feedback="invalidMessageEmail"
                    :valid-feedback="validMessageEmail"
      >
        <b-form-input
          :state="validEmail($store.person.email)"
          placeholder="Your email address"
          v-model="$store.person.email"
          class="w-100 w-md-75"
        >
        </b-form-input>
      </b-form-group>

      <b-form-group horizontal
                    description="Optionally provide your city and country so that we can anonymously map your contribution."
                    label="City & Country"
                    label-cols="2"
                    label-size="lg"
                    label-text-align="left"
                    breakpoint="md"
                    :invalid-feedback="invalidMessageCountry"
                    :valid-feedback="validMessageCountry"
      >
        <b-form-input :state="validCountry( $store.person.extras.country)"
                      placeholder="Your city & country"
                      v-model="$store.person.extras.country"
                      class="w-100 w-md-75"
        ></b-form-input>
      </b-form-group>

      <b-form-group v-if="showOrganisationFields"
                    horizontal
                    description="Are you part of an organisation? Please give your role and organisation."
                    label="Role"
                    label-cols="2"
                    label-size="lg"
                    label-text-align="left"
                    breakpoint="md"
                    :invalid-feedback="invalidMessageOrganisationName"
                    :valid-feedback="validMessageOrganisationName"
      >
        <b-form-input
          :state="validOrganisationName($store.person.extras.organisationName)"
          placeholder="Your role and name of the organisation you are associated with"
          v-model="$store.person.extras.organisationName"
          class="w-100 w-md-75 form-field"
        ></b-form-input>
      </b-form-group>

      <b-form-group horizontal
                    description="Please leave a comment. You could share a 'What if?' question or two that are inspired by the charter if you want. Alternatively you could leave a commitment of something you will do to help make National Park Cities a success."
                    label="Comment"
                    label-cols="2"
                    label-size="lg"
                    label-text-align="left"
                    breakpoint="md"
                    :invalid-feedback="invalidMessageComment"
                    :valid-feedback="validMessageComment"
      >
        <b-form-textarea :state="validComment( $store.person.extras.comment)"
                      placeholder="Your comment"
                      v-model="$store.person.extras.comment"
                      class="w-100 w-md-75"
                      rows="3"
        ></b-form-textarea>
        <div class="text-right small text-black-50">{{$store.person.extras.comment ? $store.person.extras.comment.length : 0}} / {{MAX_COMMENT_LENGTH}}</div>
      </b-form-group>

      <template>
        <div class="person__form__checkbox mb-3" @click="$store.person.extras.permissionNewsletter = !$store.person.extras.permissionNewsletter">
          <div class="d-flex">
            <div class="mb-1 NPCGreen">
              <v-icon v-if="$store.person.extras.permissionNewsletter" name="regular/check-square" scale="2.5"></v-icon>
              <v-icon v-else name="regular/square" scale="2.5"></v-icon>
            </div>
            <div class="ml-3 text-body newsletter">
              Please sign me up to the National Park City Foundation Newsletter <span class="small">(if I'm not already)</span>.
              <p class="text-danger small">{{invalidMessageNewsletterCheckbox}}</p>
            </div>
          </div>
        </div>
      </template>
      <div class="mt-4">
        <div>
          <p class="small">
            National Park City Foundation will use the information you provide on this form to stay in touch with you and to provide updates
            via email, and to count and anonymously map signatures. Location data is only ever stored in anonymous form.</p>
          <p class="small">
            We will not contact you more often than once per week, and typically it will be less than this. You can change your mind at any time by
            clicking the unsubscribe link in any email you receive from us, or contacting us at hello@nationalparkcity.org.
            Your data will be managed according to the National Park City Foundation's <a target="_blank" href="https://www.nationalparkcity.org/privacy">privacy policy</a>.
          </p>
        </div>
        <b-btn @click="save" variant="outline-primary" size="lg" class="ml-auto mr-0 d-block save-button">
          <span v-if="!savingToServer"><b-img class="d-none d-lg-inline" style="height: 1em; margin-right: 0.3em; vertical-align:text-top;" src="/static/images/aster_green_tiny.png"/>{{buttonLabel}}</span>
          <vue-simple-spinner size="small" v-if="savingToServer"/>
        </b-btn>
        <div v-if="formSubmissionTried && !validFormComputed" class="text-right NPCRed">Please correct the items highlighted in red above and try again.</div>
      </div>
    </div>
  </div>
</template>

<script>
import myfunc from '../../lib/myfunc';
import VueSimpleSpinner from 'vue-simple-spinner';

export default {
  name: 'PersonForm',
  // PERSON data is stored into the central state store
  props: {
    buttonLabel: String,
    title: {
      type: String,
      default: 'Sign the Universal Charter of National Park Cities'
    },
    showChallenges: {
      type: Boolean,
      default: true,
    },
    newsletterCheckboxTop: {
      type: Boolean,
      default: true,
    },
    showOrganisationFields: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    VueSimpleSpinner,
  },
  data () {
    return {
      MAX_COMMENT_LENGTH: 700,
      formSubmissionTried: false,
      savingToServer: false,
      familySizeOptions: [
        { value: 1, text: 'Just me', },
        { value: 2, text: 'Two of us', },
        { value: 3, text: '3 - 4', },
        { value: 5, text: '5 - 6', },
        { value: 6, text: 'More', }
      ],
      challenges: [],
    };
  },
  computed: {
    validFormComputed () {
      // I got mixed up here - trying to use method in v-if so switched to computed prop    validForm () {
      return this.validForm();
    },
    invalidMessageName () {
      return 'Please enter your name.';
    },
    invalidMessageOrganisationName () {
      return 'Please enter a role and/or organisation name.';
    },
    validMessageOrganisationName () {
      return '';
    },
    validMessageName () {
      return '';
    },
    invalidMessageCountry () {
      return 'Please enter a valid city and/or country e.g.Sydney, Australia or leave blank.';
    },
    validMessageCountry () {
      return '';
    },
    invalidMessageComment () {
      return 'Please enter a comment which is not too long or leave blank.';
    },
    validMessageComment () {
      return '';
    },
    invalidMessageEmail () {
      return 'Please enter a valid email address.';
    },
    validMessageEmail () {
      return '';
    },
    invalidMessageNewsletterCheckbox () { // this is not the same implementation as the others. Just gets set
      // return (this.formSubmissionTried && !this.$store.person.extras.permissionNewsletter) ? 'Please confirm that you wish to be sent our newsletter (even if you are already signed up).' : '';
      return '';
    }
  },
  created () {
    // var that = this;
  },
  methods: {
    validForm () {
      // console.log('this.$store.person.email', this.$store.person.email);
      // console.log('validEmail', this.validEmail(this.$store.person.email));
      return this.validName(this.$store.person.name) &&
        this.validEmail(this.$store.person.email) &&
        this.validCountry(this.$store.person.extras.country) &&
        this.validNewsletter(this.$store.person.extras.permissionNewsletter) &&
        this.validComment(this.$store.person.extras.comment) &&
        this.validOrganisationName(this.$store.person.extras.organisationName);
    },
    validName (str) {
      return !this.formSubmissionTried || (str !== null && str.trim().length > 2);
    },
    validOrganisationName (str) {
      // optional so anything ok
      return true;
    },
    validEmail (str) {
      // handle mobile where often space on end
      return !this.formSubmissionTried || (str !== null && myfunc.isEmailProbably(str.trim()));
    },
    validNewsletter (bool) {
      // optional - any val allowed
      return true;
    },
    validCountry (str) {
      // optional country
      if (!this.formSubmissionTried) return true;
      // if (str !== null && str !== '') return myfunc.isCountry(str.trim());
      return true;
    },
    validComment (str) {
      // optional comment
      if (!this.formSubmissionTried) return true;
      if (str && str.length > this.MAX_COMMENT_LENGTH) return false; // max length answer to store is 750 but we have one field which is <name>|<country>|<comment>
      return true;
    },
    resetForm () {
      this.formSubmissionTried = false;
      this.$store.person = {
        email: null,
        name: null,
        extras: {
          permissionNewsletter: false,
          organisationName: null, // added to answers as well as person,
          comment: null, // added to answers as well as person,
          country: null, // added to answers as well as person,
        },
      };
    },
    save () {
      this.formSubmissionTried = true;
      if (!this.validForm()) return;

      // Permission for map is dervied from entering a postcode not a separate checkbox
      this.$store.person.extras.permissionMap = !!this.$store.person.extras.postcode; // true if a postcode
      this.savingToServer = true;

      // Fire event 'input' used as the default event - to let it know that form entry complete
      // (Part of the v-model structure also)
      // Tho the parent will be seeing updates as they are changed dynamically not just when this fired
      this.$emit('input', this.$store.person);
    }
  }
};
</script>

<style scoped lang="scss">
  @import '../../scss/custom-bootstrap.scss';
  @import '~bootstrap/scss/bootstrap.scss';

  .person__form_outer {
    background-color: $NPCGreen;
    padding: 2em 0.8em 0.8em;
    /*padding: 2em 0.5em 1em 0.5em;*/
    margin-top: 2em;
    border-radius: 6px;

    > h3, > h5 {
      color: white;
      margin-top: 0;
      padding-left: 0.7em;
      padding-bottom: 0;
    }

  }

  .person__form {
    background-color: white;
    margin-top: 1em;
    padding: 2em;
    border: solid $NPCGreen 1px;
    border-radius: 6px;

    &__checkbox {
      color: $NPCGreen;
      cursor: pointer;
      margin-top: 1em;
    }
  }

  .medium {
    font-size: 0.9rem;
  }

  input[type="checkbox"] {
    cursor: pointer !important;
  }

  .challenge-suggestion {
    width: 100%;
    @include media-breakpoint-up(md) {
      width: 75%;
    }
  }

  .save-button {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px; // on mobile we want to limit button otherwise it overalps and pushes everything left
    @include media-breakpoint-up(md) {
      max-width: 100%;
    }
  }

  .newsletter {
    font-size: initial;
    @include media-breakpoint-up(md) {
      font-size: 1.2em;
    }
  }

  .form-field::placeholder {
    font-size: x-small;
    @include media-breakpoint-up(md) {
      font-size: initial;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/PersonFormInternational.vue